import { FC } from 'react';
import { Avatar, Box, Flex, Text } from '@mantine/core';
import { useStyles } from './styles';
import { IRowData, IUsersSortField } from '@components/simple-table/types';
import { RolesPlaceholder } from '@assets/icons';
import OverflowTip from '@components/OverflowTip';

interface IItemTitleProps {
  item: IRowData;
}

export const ItemTitle: FC<IItemTitleProps> = ({ item }) => {
  const { classes } = useStyles();

  const isLdapUser = item?.Origin === IUsersSortField.LDAP;

  return (
    <Box className={classes.title}>
      <Flex pos="relative">
        <Avatar sx={{ zIndex: 1 }} color="blue" size={40} radius={40}>
          <RolesPlaceholder size={24} />
        </Avatar>
        {isLdapUser && <Box className={classes.ldapLabel}>LDAP</Box>}
      </Flex>
      <Box className={classes.content}>
        <OverflowTip sx={{ maxWidth: '80%' }} size="sm" fw={600} color="#101828">
          {item?.Name}
        </OverflowTip>
        <Text color="dimmed" size="xs">
          ID: {item?.Id}
        </Text>
      </Box>
    </Box>
  );
};
